import React, { useState, useEffect } from "react";
import api from "../../../../api";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { useParams } from "react-router-dom";

const COLORS = ["#00C49F", "#0088FE", "#FF8042", "#FFBB28"];

const TeamTab = () => {
 const { id: workOrderId } = useParams();
 const [teams, setTeams] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const fetchTeams = async () => {
 try {
 const res = await api.get(`/team/work-order/${workOrderId}`);
 if (res.data.success) {
 setTeams(res.data.data || []);
 }
 } catch (err) {
 console.error("Team Load Error:", err);
 } finally {
 setLoading(false);
 }
 };

 if (workOrderId) fetchTeams();
 }, [workOrderId]);

 if (loading) return <p>Loading team data...</p>;

 if (!teams.length)
 return <p className="text-center text-muted mt-4">No teams assigned.</p>;

 // ===================================
 // METRICS + FIXED ROLE CHART DATA
 // ===================================

 const allMembers = teams.flatMap(t => t.engineers || []);
 const total = allMembers.length;
 const active = allMembers.filter(m => m.status === "Active").length;
 const idle = total - active;

 const roleMap = {};

 teams.forEach(team => {
 const role = team.role || "Unknown";
 const count = team.engineers?.length || 0;
 roleMap[role] = (roleMap[role] || 0) + count;
 });

 const roleChartData = Object.entries(roleMap).map(([name, value]) => ({
 name,
 value,
 }));

 // ===================================
 // UI RENDER
 // ===================================
 return (
 <Row className="g-4">

 {/* TEAM SUMMARY */}
 <Col md={4}>
 <Card className="shadow-sm border-0 rounded-3">
 <Card.Body>
 <h5 className="fw-bold mb-3">Team Overview</h5>

 <div className="mb-2">Total Members: <strong>{total}</strong></div>
 <div className="text-success mb-2">Active: <strong>{active}</strong></div>
 <div className="text-secondary">Idle: <strong>{idle}</strong></div>
 </Card.Body>
 </Card>
 </Col>

 {/* ROLE DISTRIBUTION CHART */}
 <Col md={4}>
 <Card className="shadow-sm border-0 rounded-3">
 <Card.Body>
 <h5 className="fw-bold mb-3">Role Distribution</h5>
 <PieChart width={260} height={260}>
 <Pie
 data={roleChartData}
 dataKey="value"
 nameKey="name"
 cx="50%"
 cy="50%"
 outerRadius={80}
 label
 >
 {roleChartData.map((entry, i) => (
 <Cell key={i} fill={COLORS[i % COLORS.length]} />
 ))}
 </Pie>
 <Tooltip />
 <Legend />
 </PieChart>
 </Card.Body>
 </Card>
 </Col>

 {/* TEAM MEMBERS */}
 <Col md={12}>
 <Card className="shadow-sm border-0 rounded-3">
 <Card.Body>
 <h5 className="fw-bold mb-3">Assigned Users</h5>

 {teams.map((team, idx) => (
 <div key={idx} className="mb-4">
 <h6 className="mb-3">
 <Badge bg="info" className="rounded-pill px-3 py-2 fs-6">
 {team.role || "Team Group"}
 </Badge>
 </h6>

 <Row>
 {team.engineers?.map((member, i) => (
 <Col lg={3} md={4} sm={6} xs={12} key={member._id || i} className="mb-3">
 <Card className="border-0 shadow-sm h-100">
 <Card.Body className="text-center">

 {/* NAME */}
 <h6 className="fw-bold mb-1">{member.name}</h6>

 {/* DESIGNATION / ROLE */}
 <div className="text-muted small mb-1">
 {member.designation || team.role || "—"}
 </div>

 
 <hr className="my-2" />

 {/* CONTACT INFO */}
 <div className="text-muted small">
 {member.mobile && <div> {member.mobile}</div>}
 {member.email && <div> {member.email}</div>}
 </div>

 {/* JOIN DATE */}
 {member.joinDate && (
 <div className="text-muted small mt-1">
 <strong>Joined:</strong>{" "}
 {new Date(member.joinDate).toLocaleDateString("en-IN")}
 </div>
 )}
 </Card.Body>
 </Card>
 </Col>
 ))}
 </Row>
 </div>
 ))}
 </Card.Body>
 </Card>
 </Col>

 </Row>
 );
};

export default TeamTab;
